
export const V1AccountUserRoleIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input.PlatformMessage["ListOfAccountUser"] !== undefined) {
        if (input.PlatformMessage["ListOfAccountUser"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfAccountUser"].Count;
        }

        let results: any[] = [];

        if ("AccountUser" in input.PlatformMessage["ListOfAccountUser"]) {
            for (let i = 0; i < input.PlatformMessage["ListOfAccountUser"]["AccountUser"].length; i++) {
                let accountUser = input.PlatformMessage["ListOfAccountUser"]["AccountUser"][i];

                for (let j = 0; j < accountUser["ListOfRole"]["Role"].length; j++) {
                    let role: any = accountUser["ListOfRole"]["Role"][j];

                    let row: any = {};

                    row.RowNum = i;
                    row.RowSelected = false;

                    row.USID = role.USID;
                    row.Name = role.Name;
                    row.Status = role.Status;

                    row.CreatedDatetime = role.CreatedDatetime;
                    row.LastModifiedDatetime = role.LastModifiedDatetime;
                    row.Keyword = role.Keyword;
                    row.Realm = role.Realm;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (accountUser["ListOfRole"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = accountUser["ListOfRole"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1DocumentRevisionIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input["PlatformMessage"]["ListOfDocumentRevision"] !== undefined) {
        if (input["PlatformMessage"]["ListOfDocumentRevision"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["PlatformMessage"]["ListOfDocumentRevision"].Count;
        }

        let results = [];

        if ("DocumentRevision" in input["PlatformMessage"]["ListOfDocumentRevision"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfDocumentRevision"]["DocumentRevision"].length; i++) {
                let documentRevision = input["PlatformMessage"]["ListOfDocumentRevision"]["DocumentRevision"][i];

                let row: any = {};

                row.USID = documentRevision.USID;
                row.DocumentUSID = documentRevision.DocumentUSID;
                row.DocumentID = documentRevision.DocumentID;
                row.DocumentIDPlusRevision = documentRevision.DocumentIDPlusRevision;
                row.DocumentTypeUSID = documentRevision.DocumentTypeUSID;
                row.DocumentTypeGroup = documentRevision.DocumentTypeGroup;
                row.DocumentTypeAcronym = documentRevision.DocumentTypeAcronm;
                row.Version = documentRevision.Version;
                row.Description = documentRevision.Description;
                row.Name = documentRevision.Name;
                row.Status = documentRevision.Status;
                row.DisplayStatus = documentRevision.DisplayStatus;
                row.ParentEquipmentUSID = documentRevision.ParentEquipmentUSID;
                row.Revision = documentRevision.Revision;
                row.RevisionStage = documentRevision.RevisionStage;
                row.OwnerUSID = documentRevision.OwnerUSID;
                row.OwnerUserUSID = documentRevision.OwnerUserUSID;
                row.OwnerUserName = documentRevision.OwnerUserName;
                row.ApprovalRequestUSID = documentRevision.ApprovalRequestUSID;
                row.ApprovalRequestID = documentRevision.ApprovalRequestID;
                row.RevisionChangeType = documentRevision.RevisionChangeType;
                row.DeprecatedAt = documentRevision.DeprecatedAt;
                row.ReleasedAt = documentRevision.ReleasedAt;
                row.ObsoletedAt = documentRevision.ObsoletedAt;
                row.Retrain = documentRevision.Retrain;
                row.PlatformFormInput = documentRevision.PlatformFormInput;
                row.FormDocumentRevisionUSID = documentRevision.FormDocumentRevisionUSID;
                row.ExternalID = documentRevision.ExternalID;
                row.RenderHTML = documentRevision.RenderHTML;
                row.PDFUSID = documentRevision.PDFUSID;
                row.SubRevision = documentRevision.SubRevision;
                row.DisplayRevision = documentRevision.DisplayRevision;
                row.PreCalc = documentRevision.PreCalc;
                row.Schema = documentRevision.Schema;
                row.EquipmentStatus = documentRevision.EquipmentStatus;
                row.PurchaseOrderStatus = documentRevision.PurchaseOrderStatus;
                row.LotStatus = documentRevision.LotStatus;
                row.EffectiveDate = documentRevision.EffectiveDate;
                row.PrimaryAttachmentUSID = documentRevision.PrimaryAttachmentUSID;
                row.LastZipFileUpdate = documentRevision.LastZipFileUpdate;
                row.ApprovedAt = documentRevision.ApprovedAt;
                row.SearchableContent = documentRevision.SearchableContent;
                row.CreatedDatetime = documentRevision.CreatedDatetime;
                row.LastModifiedDatetime = documentRevision.LastModifiedDatetime;
                row.Keyword = documentRevision.Keyword;
                row.Realm = documentRevision.CompanyUSID;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1ProjectPlanIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input["PlatformMessage"]["ListOfProjectPlan"] !== undefined) {
        if (input["PlatformMessage"]["ListOfProjectPlan"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["PlatformMessage"]["ListOfProjectPlan"].Count;
        }

        let results = [];

        if ("ProjectPlan" in input["PlatformMessage"]["ListOfProjectPlan"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfProjectPlan"]["ProjectPlan"].length; i++) {
                let projectPlan = input["PlatformMessage"]["ListOfProjectPlan"]["ProjectPlan"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = projectPlan.USID;
                row.ProjectPlanID = projectPlan.ProjectPlanID;
                row.Name = projectPlan.Name;
                row.ProjectPlanPhases = null;
                if (projectPlan.ListOfProjectPlanPhase !== undefined) {
                    row.ProjectPlanPhases = projectPlan.ListOfProjectPlanPhase.ProjectPlanPhase;
                }
                row.Status = projectPlan.Status;
                row.PrimaryPositionUSID = projectPlan.PrimaryPositionUSID;
                row.PrimaryPositionName = projectPlan.PrimaryPositionName;
                row.PrimaryPositionPrimaryAccountUserUSID = projectPlan.PrimaryPositionPrimaryAccountUserUSID;
                row.PrimaryPositionPrimaryUserName = projectPlan.PrimaryPositionPrimaryUserName;
                row.PrimaryUserGroupUSID = projectPlan.PrimaryUserGroupUSID;
                row.PrimaryUserGroupName = projectPlan.PrimaryUserGroupName;
                row.PrimaryUserGroupPrimaryAccountUserUSID = projectPlan.PrimaryUserGroupPrimaryAccountUserUSID;
                row.PrimaryUserGroupPrimaryUserName = projectPlan.PrimaryUserGroupPrimaryUserName;
                row.PrimaryWorkGroupUSID = projectPlan.PrimaryWorkGroupUSID;
                row.PrimaryWorkGroupName = projectPlan.PrimaryWorkGroupName;
                row.PrimaryWorkGroupPrimaryAccountUserUSID = projectPlan.PrimaryWorkGroupPrimaryAccountUserUSID;
                row.PrimaryWorkGroupPrimaryUserName = projectPlan.PrimaryWorkGroupPrimaryUserName;
                row.NumberOfDonePhases = projectPlan.NumberOfDonePhases;
                row.CreatedByUSID = projectPlan.CreatedByUSID;
                row.CreatedByUserUSID = projectPlan.CreatedByUserUSID;
                row.CreatedByUserEmail = projectPlan.CreatedByUserEmail;
                row.CreatedByUserName = projectPlan.CreatedByUserName;
                row.CompletedOnDatetime = projectPlan.CompletedOnDatetime;
                row.CreatedDatetime = projectPlan.CreatedDatetime;
                row.GlobalLastModifiedDatetime = projectPlan.GlobalLastModifiedDatetime;
                row.GlobalLastModifiedByUserUSID = projectPlan.GlobalLastModifiedByUserUSID;
                row.GlobalLastModifiedByUserEmail = projectPlan.GlobalLastModifiedByUserEmail;
                row.GlobalLastModifiedByUserName = projectPlan.GlobalLastModifiedByUserName;
                row.PlanToCopyUSID = null;
                row.PlanToCopyNewName = null;
                row.PlanToCopyNewProjectID = null;
                row.LastModifiedDatetime = projectPlan.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
};

export const V1ProjectPlanAuditIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input.PlatformMessage["ListOfProjectPlan"] !== undefined) {
        if (input.PlatformMessage["ListOfProjectPlan"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfProjectPlan"].Count;
        }

        let results: any[] = [];

        if ("ProjectPlan" in input.PlatformMessage["ListOfProjectPlan"]) {
            for (let i = 0; i < input.PlatformMessage["ListOfProjectPlan"]["ProjectPlan"].length; i++) {
                let projectPlan = input.PlatformMessage["ListOfProjectPlan"]["ProjectPlan"][i];

                for (let j = 0; j < projectPlan["ListOfProjectMilestoneAuditHistory"]["ProjectMilestoneAuditHistory"].length; j++) {
                    let auditLog: any = projectPlan["ListOfProjectMilestoneAuditHistory"]["ProjectMilestoneAuditHistory"][j];

                    let row: any = {};

                    let unordered = JSON.parse(atob(auditLog.Change));
                    const ordered = Object.keys(unordered).sort().reduce(
                        (obj: any, key: string) => {
                            obj[key] = unordered[key];
                            return obj;
                        },
                        {}
                    );

                    row.RowSelected = false;
                    row.USID = auditLog.USID;
                    row.ModificationType = auditLog.ModificationType;
                    row.SerialNumberUSID = auditLog.SerialNumberUSID;
                    row.ProjectPlanUSID = auditLog.ProjectPlanUSID;
                    row.ProjectPlanName = auditLog.ProjectPlanName;
                    row.ProjectPlanPhaseUSID = auditLog.ProjectPlanPhaseUSID;
                    row.ProjectPlanPhaseName = auditLog.ProjectPlanPhaseName;
                    row.ProjectPlanPhaseAttachmentUSID = auditLog.ProjectPlanPhaseAttachmentUSID;
                    row.ProjectPlanPhaseApprovalUSID = auditLog.ProjectPlanPhaseApprovalUSID;
                    row.ProjectPlanPhaseMilestoneUSID = auditLog.ProjectPlanPhaseMilestoneUSID;
                    row.ProjectPlanPhaseMilestoneName = auditLog.ProjectPlanPhaseMilestoneName;
                    row.ProjectPlanPhaseMilestoneReferenceUSID = auditLog.ProjectPlanPhaseMilestoneReferenceUSID;
                    row.Change = ordered;
                    row.CreatedByUSID = auditLog.CreatedByUSID;
                    row.CreatedByName = auditLog.CreatedByName;
                    row.CreatedByEmail = auditLog.CreatedByEmail;
                    row.CreatedDatetime = auditLog.CreatedDatetime;
                    row.LastModifiedDatetime = auditLog.LastModifiedDatetime;
                    row.Action = null;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (projectPlan["ListOfProjectMilestoneAuditHistory"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = projectPlan["ListOfProjectMilestoneAuditHistory"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1ProjectMilestoneSessionIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input["PlatformMessage"]["ListOfProjectMilestoneSession"] !== undefined) {
        if (input["PlatformMessage"]["ListOfProjectMilestoneSession"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["PlatformMessage"]["ListOfProjectMilestoneSession"].Count;
        }

        let results = [];

        if ("ProjectMilestoneSession" in input["PlatformMessage"]["ListOfProjectMilestoneSession"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfProjectMilestoneSession"]["ProjectMilestoneSession"].length; i++) {
                let projectMilestoneSession = input["PlatformMessage"]["ListOfProjectMilestoneSession"]["ProjectMilestoneSession"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = projectMilestoneSession.USID;
                row.AccountUserUSID = projectMilestoneSession.AccountUserUSID;
                row.UserAgent = projectMilestoneSession.UserAgent;
                row.IPAddress = projectMilestoneSession.IPAddress;
                row.NumberOfAuditActions = projectMilestoneSession.NumberOfAuditActions;
                row.CreatedDatetime = projectMilestoneSession.CreatedDatetime;
                row.LastModifiedDatetime = projectMilestoneSession.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
};

export const V1ProjectMilestoneAuditHistoryIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input.PlatformMessage["ListOfProjectMilestoneSession"] !== undefined) {
        if (input.PlatformMessage["ListOfProjectMilestoneSession"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfProjectMilestoneSession"].Count;
        }

        let results: any[] = [];

        if ("ProjectMilestoneSession" in input.PlatformMessage["ListOfProjectMilestoneSession"]) {
            for (let i = 0; i < input.PlatformMessage["ListOfProjectMilestoneSession"]["ProjectMilestoneSession"].length; i++) {
                let projectMilestoneSession = input.PlatformMessage["ListOfProjectMilestoneSession"]["ProjectMilestoneSession"][i];

                for (let j = 0; j < projectMilestoneSession["ListOfProjectMilestoneAuditHistory"]["ProjectMilestoneAuditHistory"].length; j++) {
                    let projectMilestoneAuditHistory: any = projectMilestoneSession["ListOfProjectMilestoneAuditHistory"]["ProjectMilestoneAuditHistory"][j];

                    let row: any = {};

                    let unordered = JSON.parse(atob(projectMilestoneAuditHistory.Change));
                    const ordered = Object.keys(unordered).sort().reduce(
                        (obj: any, key: string) => {
                            obj[key] = unordered[key];
                            return obj;
                        },
                        {}
                    );

                    row.RowSelected = false;
                    row.USID = projectMilestoneAuditHistory.USID;
                    row.ModificationType = projectMilestoneAuditHistory.ModificationType;
                    row.SerialNumberUSID = projectMilestoneAuditHistory.SerialNumberUSID;
                    row.SessionIdentifier = projectMilestoneAuditHistory.SessionIdentifier;
                    row.ProjectPlanUSID = projectMilestoneAuditHistory.ProjectPlanUSID;
                    row.ProjectPlanName = projectMilestoneAuditHistory.ProjectPlanName;
                    row.ProjectPlanPhaseUSID = projectMilestoneAuditHistory.ProjectPlanPhaseUSID;
                    row.ProjectPlanPhaseName = projectMilestoneAuditHistory.ProjectPlanPhaseName;
                    row.ProjectPlanPhaseAttachmentUSID = projectMilestoneAuditHistory.ProjectPlanPhaseAttachmentUSID;
                    row.ProjectPlanPhaseMilestoneUSID = projectMilestoneAuditHistory.ProjectPlanPhaseMilestoneUSID;
                    row.ProjectPlanPhaseMilestoneName = projectMilestoneAuditHistory.ProjectPlanPhaseMilestoneName;
                    row.ProjectPlanPhaseMilestoneReferenceUSID = projectMilestoneAuditHistory.ProjectPlanPhaseMilestoneReferenceUSID;
                    row.Change = ordered;
                    row.CreatedByUSID = projectMilestoneAuditHistory.CreatedByUSID;
                    row.CreatedByName = projectMilestoneAuditHistory.CreatedByName;
                    row.CreatedByEmail = projectMilestoneAuditHistory.CreatedByEmail;
                    row.CreatedDatetime = projectMilestoneAuditHistory.CreatedDatetime;
                    row.LastModifiedDatetime = projectMilestoneAuditHistory.LastModifiedDatetime;
                    row.Action = null;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (projectMilestoneSession["ListOfProjectMilestoneAuditHistory"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = projectMilestoneSession["ListOfProjectMilestoneAuditHistory"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1ProjectPlanPhaseIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input.PlatformMessage["ListOfProjectPlanPhase"] !== undefined) {
        if (input.PlatformMessage["ListOfProjectPlanPhase"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfProjectPlanPhase"].Count;
        }

        let results = [];

        if ("ProjectPlanPhase" in input["PlatformMessage"]["ListOfProjectPlanPhase"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfProjectPlanPhase"]["ProjectPlanPhase"].length; i++) {
                let projectPlanPhase = input["PlatformMessage"]["ListOfProjectPlanPhase"]["ProjectPlanPhase"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = projectPlanPhase.USID;
                row.ProjectPlanUSID = projectPlanPhase.ProjectPlanUSID;
                row.Name = projectPlanPhase.Name;
                row.Description = projectPlanPhase.Description;
                row.Status = projectPlanPhase.Status;
                row.StartDatetime = projectPlanPhase.StartDatetime;
                row.DueDatetime = projectPlanPhase.DueDatetime;
                row.Notes = projectPlanPhase.Notes;
                row.Justification = projectPlanPhase.Justification;
                row.PhaseToCopyUSID = null;
                row.PhaseToCopyNewName = null;
                row.NumberOfMilestonesInInProgressStatus = projectPlanPhase.NumberOfMilestonesInInProgressStatus;
                row.NumberOfMilestonesInDoneStatus = projectPlanPhase.NumberOfMilestonesInDoneStatus;
                row.CreatedDatetime = projectPlanPhase.CreatedDatetime;
                row.LastModifiedDatetime = projectPlanPhase.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1ProjectPlanChartIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input.PlatformMessage["ListOfProjectPlanChart"] !== undefined) {
        if (input.PlatformMessage["ListOfProjectPlanChart"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfProjectPlanChart"].Count;
        }

        let results = [];

        if ("ProjectPlanChart" in input["PlatformMessage"]["ListOfProjectPlanChart"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfProjectPlanChart"]["ProjectPlanChart"].length; i++) {
                let projectPlanChart = input["PlatformMessage"]["ListOfProjectPlanChart"]["ProjectPlanChart"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = projectPlanChart.USID;
                row.X_AXIS = projectPlanChart.X_AXIS;
                row.Y_AXIS_1 = projectPlanChart.Y_AXIS_1;
                row.Y_AXIS_2 = projectPlanChart.Y_AXIS_2;
                row.CreatedDatetime = projectPlanChart.CreatedDatetime;
                row.LastModifiedDatetime = projectPlanChart.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1ProjectPlanPhaseMilestoneIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input.PlatformMessage["ListOfProjectPlanPhaseMilestone"] !== undefined) {
        if (input.PlatformMessage["ListOfProjectPlanPhaseMilestone"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfProjectPlanPhaseMilestone"].Count;
        }

        let results = [];

        if ("ProjectPlanPhaseMilestone" in input["PlatformMessage"]["ListOfProjectPlanPhaseMilestone"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfProjectPlanPhaseMilestone"]["ProjectPlanPhaseMilestone"].length; i++) {
                let projectPlanPhaseMilestone = input["PlatformMessage"]["ListOfProjectPlanPhaseMilestone"]["ProjectPlanPhaseMilestone"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = projectPlanPhaseMilestone.USID;
                row.ProjectPlanPhaseUSID = projectPlanPhaseMilestone.ProjectPlanPhaseUSID;
                row.ProjectPlanPhaseStatus = projectPlanPhaseMilestone.ProjectPlanPhaseStatus;
                row.ProjectPlanPhaseName = projectPlanPhaseMilestone.ProjectPlanPhaseName;
                row.Name = projectPlanPhaseMilestone.Name;
                row.Description = projectPlanPhaseMilestone.Description;
                row.Status = projectPlanPhaseMilestone.Status;
                row.StartDatetime = projectPlanPhaseMilestone.StartDatetime;
                row.DueDatetime = projectPlanPhaseMilestone.DueDatetime;
                row.Notes = projectPlanPhaseMilestone.Notes;
                row.MilestoneToCopyUSID = null;
                row.MilestoneToCopyNewName = null;
                row.CreatedDatetime = projectPlanPhaseMilestone.CreatedDatetime;
                row.LastModifiedDatetime = projectPlanPhaseMilestone.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1ProjectPlanPhaseApprovalIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input.PlatformMessage["ListOfProjectPlanPhaseApproval"] !== undefined) {
        if (input.PlatformMessage["ListOfProjectPlanPhaseApproval"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfProjectPlanPhaseApproval"].Count;
        }

        let results = [];

        if ("ProjectPlanPhaseApproval" in input["PlatformMessage"]["ListOfProjectPlanPhaseApproval"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfProjectPlanPhaseApproval"]["ProjectPlanPhaseApproval"].length; i++) {
                let projectPlanPhaseApproval = input["PlatformMessage"]["ListOfProjectPlanPhaseApproval"]["ProjectPlanPhaseApproval"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = projectPlanPhaseApproval.USID;
                row.ProjectPlanPhaseUSID = projectPlanPhaseApproval.ProjectPlanPhaseUSID;
                row.ProjectPlanPhaseStatus = projectPlanPhaseApproval.ProjectPlanPhaseStatus;
                row.Status = projectPlanPhaseApproval.Status;
                row.SubmissionDatetime = projectPlanPhaseApproval.SubmissionDatetime;
                row.ApprovalDatetime = projectPlanPhaseApproval.ApprovalDatetime;
                row.AccountUserUSID = projectPlanPhaseApproval.AccountUserUSID;
                row.EmployeeUserName = projectPlanPhaseApproval.EmployeeUserName;
                row.EmployeeUserEmail = projectPlanPhaseApproval.EmployeeUserEmail;
                row.CreatedDatetime = projectPlanPhaseApproval.CreatedDatetime;
                row.LastModifiedDatetime = projectPlanPhaseApproval.LastModifiedDatetime;
                row.Submit = false;
                row.Withdraw = false;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1ProjectPlanPhaseMilestoneReferenceIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input.PlatformMessage["ListOfProjectPlanPhaseMilestoneReference"] !== undefined) {
        if (input.PlatformMessage["ListOfProjectPlanPhaseMilestoneReference"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfProjectPlanPhaseMilestoneReference"].Count;
        }

        let results = [];

        if ("ProjectPlanPhaseMilestoneReference" in input["PlatformMessage"]["ListOfProjectPlanPhaseMilestoneReference"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfProjectPlanPhaseMilestoneReference"]["ProjectPlanPhaseMilestoneReference"].length; i++) {
                let projectPlanPhaseMilestoneReference = input["PlatformMessage"]["ListOfProjectPlanPhaseMilestoneReference"]["ProjectPlanPhaseMilestoneReference"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = projectPlanPhaseMilestoneReference.USID;
                row.ProjectPlanPhaseMilestoneUSID = projectPlanPhaseMilestoneReference.ProjectPlanPhaseMilestoneUSID;
                row.ParentUSID = projectPlanPhaseMilestoneReference.ParentUSID;
                row.MilestoneName = projectPlanPhaseMilestoneReference.MilestoneName;
                row.MilestoneStatus = projectPlanPhaseMilestoneReference.MilestoneStatus;
                row.PhaseStatus = projectPlanPhaseMilestoneReference.PhaseStatus;
                row.ReferenceType = projectPlanPhaseMilestoneReference.ReferenceType;
                row.DocumentRevisionUSID = projectPlanPhaseMilestoneReference.DocumentRevisionUSID;
                row.DocumentID = projectPlanPhaseMilestoneReference.DocumentID;
                row.DocumentUSID = projectPlanPhaseMilestoneReference.DocumentUSID;
                row.DocumentTypeGroup = projectPlanPhaseMilestoneReference.DocumentTypeGroup;
                row.Name = projectPlanPhaseMilestoneReference.Name;
                row.Status = projectPlanPhaseMilestoneReference.Status;
                row.DisplayStatus = projectPlanPhaseMilestoneReference.DisplayStatus;
                row.DisplayRevision = projectPlanPhaseMilestoneReference.DisplayRevision;
                row.DocumentIDPlusRevision = projectPlanPhaseMilestoneReference.DocumentIDPlusRevision;
                row.ApprovalRequestUSID = projectPlanPhaseMilestoneReference.ApprovalRequestUSID;
                row.ApprovalRequestID = projectPlanPhaseMilestoneReference.ApprovalRequestID;
                row.ReleasedAt = projectPlanPhaseMilestoneReference.ReleasedAt;
                row.Comment = projectPlanPhaseMilestoneReference.Comment;
                row.PurchaseOrderStatus = projectPlanPhaseMilestoneReference.PurchaseOrderStatus;
                row.EquipmentStatus = projectPlanPhaseMilestoneReference.EquipmentStatus;
                row.LotStatus = projectPlanPhaseMilestoneReference.LotStatus;
                row.SearchableContent = projectPlanPhaseMilestoneReference.SearchableContent;
                row.ChildRecords = projectPlanPhaseMilestoneReference.ChildRecords;
                row.CreatedDatetime = projectPlanPhaseMilestoneReference.CreatedDatetime;
                row.LastModifiedDatetime = projectPlanPhaseMilestoneReference.LastModifiedDatetime;

                if (row.ChildRecords !== undefined) {
                    row.path = row.DocumentIDPlusRevision
                    calculatePath(results, row, row.DocumentIDPlusRevision)
                }
                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

const calculatePath = (results: any[], row: any, path?: string | undefined) => {
    for (let i = 0; i < row.ChildRecords.length; i++) {
        path = path + "/" + row.ChildRecords[i].DocumentIDPlusRevision
        row.ChildRecords[i].path = path;
        results.push(row.ChildRecords[i]);

        calculatePath(results, row.ChildRecords[i], path)
    }
};

export const V1ProjectPlanPhaseMilestoneEmployeeIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input.PlatformMessage["ListOfProjectPlanPhaseMilestoneEmployee"] !== undefined) {
        if (input.PlatformMessage["ListOfProjectPlanPhaseMilestoneEmployee"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfProjectPlanPhaseMilestoneEmployee"].Count;
        }

        let results = [];

        if ("ProjectPlanPhaseMilestoneEmployee" in input["PlatformMessage"]["ListOfProjectPlanPhaseMilestoneEmployee"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfProjectPlanPhaseMilestoneEmployee"]["ProjectPlanPhaseMilestoneEmployee"].length; i++) {
                let projectPlanPhaseMilestoneEmployee = input["PlatformMessage"]["ListOfProjectPlanPhaseMilestoneEmployee"]["ProjectPlanPhaseMilestoneEmployee"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = projectPlanPhaseMilestoneEmployee.USID;
                row.ProjectPlanPhaseMilestoneUSID = projectPlanPhaseMilestoneEmployee.ProjectPlanPhaseMilestoneUSID;
                row.AccountUserUSID = projectPlanPhaseMilestoneEmployee.AccountUserUSID;
                row.EmployeeName = projectPlanPhaseMilestoneEmployee.EmployeeName;
                row.CreatedDatetime = projectPlanPhaseMilestoneEmployee.CreatedDatetime;
                row.LastModifiedDatetime = projectPlanPhaseMilestoneEmployee.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1ProjectPlanPhaseMilestoneAttachmentIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input.PlatformMessage["ListOfProjectPlanPhaseMilestoneAttachment"] !== undefined) {
        if (input.PlatformMessage["ListOfProjectPlanPhaseMilestoneAttachment"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfProjectPlanPhaseMilestoneAttachment"].Count;
        }

        let results = [];

        if ("ProjectPlanPhaseMilestoneAttachment" in input["PlatformMessage"]["ListOfProjectPlanPhaseMilestoneAttachment"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfProjectPlanPhaseMilestoneAttachment"]["ProjectPlanPhaseMilestoneAttachment"].length; i++) {
                let projectPlanPhaseMilestoneAttachment = input["PlatformMessage"]["ListOfProjectPlanPhaseMilestoneAttachment"]["ProjectPlanPhaseMilestoneAttachment"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = projectPlanPhaseMilestoneAttachment.USID;
                row.ProjectPlanPhaseMilestoneUSID = projectPlanPhaseMilestoneAttachment.ProjectPlanPhaseMilestoneUSID;
                row.MilestoneName = projectPlanPhaseMilestoneAttachment.MilestoneName;
                row.MilestoneStatus = projectPlanPhaseMilestoneAttachment.MilestoneStatus;
                row.PhaseStatus = projectPlanPhaseMilestoneAttachment.PhaseStatus;
                row.Name = projectPlanPhaseMilestoneAttachment.Name;
                row.FileSize = projectPlanPhaseMilestoneAttachment.FileSize;
                row.Type = projectPlanPhaseMilestoneAttachment.Type;
                row.OwnerUserName = projectPlanPhaseMilestoneAttachment.OwnerUserName;
                row.CreatedDatetime = projectPlanPhaseMilestoneAttachment.CreatedDatetime;
                row.LastModifiedDatetime = projectPlanPhaseMilestoneAttachment.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1ProjectPlanPhaseAttachmentIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input.PlatformMessage["ListOfProjectPlanPhaseAttachment"] !== undefined) {
        if (input.PlatformMessage["ListOfProjectPlanPhaseAttachment"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfProjectPlanPhaseAttachment"].Count;
        }

        let results = [];

        if ("ProjectPlanPhaseAttachment" in input["PlatformMessage"]["ListOfProjectPlanPhaseAttachment"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfProjectPlanPhaseAttachment"]["ProjectPlanPhaseAttachment"].length; i++) {
                let projectPlanPhaseAttachment = input["PlatformMessage"]["ListOfProjectPlanPhaseAttachment"]["ProjectPlanPhaseAttachment"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = projectPlanPhaseAttachment.USID;
                row.ProjectPlanPhaseUSID = projectPlanPhaseAttachment.ProjectPlanPhaseUSID;
                row.AttachmentUSID = projectPlanPhaseAttachment.AttachmentUSID;
                row.Name = projectPlanPhaseAttachment.Name;
                row.FileSize = projectPlanPhaseAttachment.FileSize;
                row.Type = projectPlanPhaseAttachment.Type;
                row.OwnerUserName = projectPlanPhaseAttachment.OwnerUserName;
                row.CreatedDatetime = projectPlanPhaseAttachment.CreatedDatetime;
                row.LastModifiedDatetime = projectPlanPhaseAttachment.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1AccountUserIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input["PlatformMessage"]["ListOfAccountUser"] !== undefined) {
        if (input["PlatformMessage"]["ListOfAccountUser"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["PlatformMessage"]["ListOfAccountUser"].Count;
        }

        let results = [];

        if ("AccountUser" in input["PlatformMessage"]["ListOfAccountUser"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfAccountUser"]["AccountUser"].length; i++) {
                let accountUser = input["PlatformMessage"]["ListOfAccountUser"]["AccountUser"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = accountUser.USID;
                row.UserUSID = accountUser.UserUSID;
                row.Email = accountUser.Email;
                row.Name = accountUser.Name;
                row.Confirmed = accountUser.Confirmed;
                row.Locked = accountUser.Locked;
                row.UserStatus = accountUser.UserStatus;
                row.EmailVerificationState = accountUser.EmailVerificationState;
                row.EmailVerificationDatetime = accountUser.EmailVerificationDatetime;
                row.CreatedDatetime = accountUser.CreatedDatetime;
                row.LastModifiedDatetime = accountUser.LastModifiedDatetime;
                row.Action = null;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
};

export const V1UserIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input["PlatformMessage"]["ListOfUser"] !== undefined) {
        if (input["PlatformMessage"]["ListOfUser"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["PlatformMessage"]["ListOfUser"].Count;
        }

        let results = [];

        if ("User" in input["PlatformMessage"]["ListOfUser"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfUser"]["User"].length; i++) {
                let user = input["PlatformMessage"]["ListOfUser"]["User"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = user.USID;
                row.Email = user.Email;
                row.Name = user.Name;
                row.Active = user.Active;
                row.CreatedDatetime = user.CreatedDatetime;
                row.LastModifiedDatetime = user.LastModifiedDatetime;
                row.Action = null;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
};

export const V1UserEmailToArray = (input: any): { Results: any } => {
    const row = {
        Name:                    input?.["Name"],
        MemberOfAnotherAccount:  input?.["MemberOfAnotherAccount"],
        MemberOfAccount:         input?.["MemberOfAccount"],
        InvitationInProgress:    input?.["InvitationInProgress"],
        InvitationDatetime:      input?.["InvitationDatetime"],
        UserUSID:                input?.["UserUSID"],
        EmailVerificationState:  input?.["EmailVerificationState"],
    };

    let results = [];
    results.push(row);

    return {
        Results: results
    };
};

export const V1InvitationIDOCToArray = (input: any) => {
    let output: any = {};

    let results: any[] = [];

    if ("Invitation" in input.PlatformMessage) {
        let invitation = input.PlatformMessage["Invitation"];
        let row: any = {};

        row.USID = invitation.USID;
        row.UserUSID = invitation.UserUSID;
        row.InvitationStatus = invitation.InvitationStatus;
        row.InvitationDatetime = invitation.InvitationDatetime;

        row["__operation"] = "query results";

        results.push(row);
    }
    output["Results"] = results;

    return output;
};

export const V1PositionMembershipIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input["PlatformMessage"] && input["PlatformMessage"]["ListOfPositionMembership"] !== undefined) {
        if (input["PlatformMessage"]["ListOfPositionMembership"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["PlatformMessage"]["ListOfPositionMembership"].Count;
        }

        let results = [];

        if ("PositionMembership" in input["PlatformMessage"]["ListOfPositionMembership"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfPositionMembership"]["PositionMembership"].length; i++) {
                let positionMembership = input["PlatformMessage"]["ListOfPositionMembership"]["PositionMembership"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = positionMembership.USID;
                row.SourceUSID = positionMembership.SourceUSID;
                row.SourceType = positionMembership.SourceType;
                row.PositionUSID = positionMembership.PositionUSID;
                row.PositionName = positionMembership.PositionName;
                row.PrimaryAccountUserUSID = positionMembership.PrimaryAccountUserUSID;
                row.PrimaryAccountUserName = positionMembership.PrimaryAccountUserName;
                // GUARDED LIKE ITS TWO NEIGHBOURS. A member list the IDOC omits -- the node is
                // "One or More", so an owner with nobody in it has no ListOfAccountUser at all --
                // reaches this line as undefined, and `.AccountUser` on it throws
                // "Cannot read properties of undefined (reading 'AccountUser')", which the EC
                // reports as a System Error modal over the whole tab rather than an empty column.
                // That is exactly the crash a stale bundle hit against the moved user-group shape
                // on 2026-10-07. No position in prod has zero members today, so this one is
                // symmetry with the work group and user group mappers, not a repair of anything
                // observed.
                const positionAccountUsers = positionMembership.Position?.ListOfAccountUser?.AccountUser;
                row.AccountUsers = positionAccountUsers === undefined || positionAccountUsers === null
                    ? [] : (Array.isArray(positionAccountUsers) ? positionAccountUsers : [positionAccountUsers]);
                row.Realm = positionMembership.Realm;
                row.CreatedDatetime = positionMembership.CreatedDatetime;
                row.LastModifiedDatetime = positionMembership.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
};

export const V1UserGroupMembershipIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input["PlatformMessage"] && input["PlatformMessage"]["ListOfUserGroupMembership"] !== undefined) {
        if (input["PlatformMessage"]["ListOfUserGroupMembership"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["PlatformMessage"]["ListOfUserGroupMembership"].Count;
        }

        let results = [];

        if ("UserGroupMembership" in input["PlatformMessage"]["ListOfUserGroupMembership"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfUserGroupMembership"]["UserGroupMembership"].length; i++) {
                let adminUserGroupMembership = input["PlatformMessage"]["ListOfUserGroupMembership"]["UserGroupMembership"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = adminUserGroupMembership.USID;
                row.SourceUSID = adminUserGroupMembership.SourceUSID;
                row.SourceType = adminUserGroupMembership.SourceType;
                row.UserGroupUSID = adminUserGroupMembership.UserGroupUSID;
                row.UserGroupName = adminUserGroupMembership.UserGroupName;
                row.PrimaryAccountUserUSID = adminUserGroupMembership.PrimaryAccountUserUSID;
                row.PrimaryAccountUserName = adminUserGroupMembership.PrimaryAccountUserName;
                // THE MEMBERS COME FROM THE GROUP, not from the membership row.
                //
                // USER_GROUP_MEMBERSHIP holds one row per record shared into the group, so while
                // AccountUser hung off the membership row the list arrived multiplied by the number
                // of shares -- each of a board's five members drawn three times on SOP-00003. The
                // IDOC now interposes UserGroup, as PositionMembership-002 has always interposed
                // Position. Both shapes are read so the page is correct either side of the core
                // deploy that moves it.
                const userGroupAccountUsers = adminUserGroupMembership.UserGroup?.ListOfAccountUser
                    ? adminUserGroupMembership.UserGroup.ListOfAccountUser.AccountUser
                    : adminUserGroupMembership.ListOfAccountUser?.AccountUser;
                row.AccountUsers = userGroupAccountUsers === undefined || userGroupAccountUsers === null
                    ? [] : (Array.isArray(userGroupAccountUsers) ? userGroupAccountUsers : [userGroupAccountUsers]);
                row.Realm = adminUserGroupMembership.Realm;
                row.CreatedDatetime = adminUserGroupMembership.CreatedDatetime;
                row.LastModifiedDatetime = adminUserGroupMembership.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
};

export const V1WorkGroupMembershipIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input["PlatformMessage"] && input["PlatformMessage"]["ListOfWorkGroupMembership"] !== undefined) {
        if (input["PlatformMessage"]["ListOfWorkGroupMembership"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input["PlatformMessage"]["ListOfWorkGroupMembership"].Count;
        }

        let results = [];

        if ("WorkGroupMembership" in input["PlatformMessage"]["ListOfWorkGroupMembership"]) {
            for (let i = 0; i < input["PlatformMessage"]["ListOfWorkGroupMembership"]["WorkGroupMembership"].length; i++) {
                let adminWorkGroupMembership = input["PlatformMessage"]["ListOfWorkGroupMembership"]["WorkGroupMembership"][i];

                let row: any = {};

                row.RowSelected = false;
                row.USID = adminWorkGroupMembership.USID;
                row.SourceUSID = adminWorkGroupMembership.SourceUSID;
                row.SourceType = adminWorkGroupMembership.SourceType;
                row.WorkGroup = adminWorkGroupMembership.WorkGroup;
                row.WorkGroupUSID = adminWorkGroupMembership.WorkGroupUSID;
                row.WorkGroupName = adminWorkGroupMembership.WorkGroupName;
                row.PrimaryAccountUserUSID = adminWorkGroupMembership.PrimaryAccountUserUSID;
                row.PrimaryAccountUserName = adminWorkGroupMembership.PrimaryAccountUserName;
                row.Realm = adminWorkGroupMembership.Realm;
                row.CreatedDatetime = adminWorkGroupMembership.CreatedDatetime;
                row.LastModifiedDatetime = adminWorkGroupMembership.LastModifiedDatetime;

                row["__operation"] = "query results";

                results.push(row);
            }
        }

        output["Results"] = results;
    }
    return output;
};

export const V1OrganizationIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input["PlatformMessage"] && input.PlatformMessage["ListOfOrganization"] !== undefined) {
        if (input.PlatformMessage["ListOfOrganization"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfOrganization"].Count;
        }

        let results: any[] = [];

        if ("Organization" in input.PlatformMessage["ListOfOrganization"]) {
            for (let i = 0; i < input.PlatformMessage["ListOfOrganization"]["Organization"].length; i++) {
                let organization = input.PlatformMessage["ListOfOrganization"]["Organization"][i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = organization.USID;
                row.ParentUSID = organization.ParentUSID;
                row.ParentOrganizationName = organization.ParentOrganizationName;
                row.OrganizationType = organization.OrganizationType;
                row.Name = organization.Name;
                row.Status = organization.Status;

                row.CreatedDatetime = organization.CreatedDatetime;
                row.LastModifiedDatetime = organization.LastModifiedDatetime;
                row.Keyword = organization.Keyword;
                row.Realm = organization.Realm;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }

    return output;
};

export const V1DocumentTypeIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input.PlatformMessage["ListOfDocumentType"] !== undefined) {
        if (input.PlatformMessage["ListOfDocumentType"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfDocumentType"].Count;
        }

        let results: any[] = [];

        if ("DocumentType" in input.PlatformMessage["ListOfDocumentType"]) {
            for (let i = 0; i < input.PlatformMessage["ListOfDocumentType"]["DocumentType"].length; i++) {
                let documentType = input.PlatformMessage["ListOfDocumentType"]["DocumentType"][i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = documentType.USID;
                row.DocumentTypeName = documentType.DocumentTypeName;
                row.DocumentTypeAcronym = documentType.DocumentTypeAcronym;
                row.DocumentTypeGroup = documentType.DocumentTypeGroup;
                row.PrivateNumberPool = documentType.PrivateNumberPool;
                row.StartingNumber = documentType.StartingNumber;
                row.DefaultSchema = documentType.DefaultSchema;
                row.Active = documentType.Active;
                row.DefaultRevisionStage = documentType.DefaultRevisionStage;
                row.NumberOfDocumentDigits = documentType.NumberOfDocumentDigits;
                row.NumberOfDocuments = documentType.NumberOfDocuments;

                row.Realm = documentType.Realm;
                row.CreatedDatetime = documentType.CreatedDatetime;
                row.LastModifiedDatetime = documentType.LastModifiedDatetime;
                row.RowIdentity = documentType.RowIdentity;
                row.Keyword = documentType.Keyword;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }

    return output;
};

export const V1OrganizationPositionIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input.PlatformMessage["ListOfOrganization"] !== undefined) {
        if (input.PlatformMessage["ListOfOrganization"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfOrganization"].Count;
        }

        let results: any[] = [];

        if ("Organization" in input.PlatformMessage["ListOfOrganization"]) {
            for (let i = 0; i < input.PlatformMessage["ListOfOrganization"]["Organization"].length; i++) {
                let organization = input.PlatformMessage["ListOfOrganization"]["Organization"][i];

                for (let j = 0; j < organization["ListOfPosition"]["Position"].length; j++) {
                    let position: any = organization["ListOfPosition"]["Position"][j];

                    let row: any = {};

                    row.RowSelected = false;
                    row.USID = position.USID;
                    row.ParentUSID = position.ParentUSID;
                    row.ParentPositionName = position.ParentPositionName;
                    row.PrimaryAccountUserUSID = position.PrimaryAccountUserUSID;
                    row.PrimaryAccountUserName = position.PrimaryAccountUserName;
                    row.OrganizationUSID = position.OrganizationUSID;
                    row.OrganizationName = position.OrganizationName;
                    row.Name = position.Name;
                    row.Status = position.Status;
                    row.CreatedDatetime = position.CreatedDatetime;
                    row.LastModifiedDatetime = position.LastModifiedDatetime;
                    row.Action = null;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (organization["ListOfPosition"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = organization["ListOfPosition"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1PositionIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input.PlatformMessage["ListOfPosition"] !== undefined) {
        if (input.PlatformMessage["ListOfPosition"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfPosition"].Count;
        }

        let results: any[] = [];

        if ("Position" in input.PlatformMessage["ListOfPosition"]) {
            for (let i = 0; i < input.PlatformMessage["ListOfPosition"]["Position"].length; i++) {
                let position = input.PlatformMessage["ListOfPosition"]["Position"][i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = position.USID;
                row.ParentUSID = position.ParentUSID;
                row.ParentPositionName = position.ParentPositionName;
                row.PrimaryAccountUserUSID = position.PrimaryAccountUserUSID;
                row.PrimaryAccountUserName = position.PrimaryAccountUserName;
                // The account users holding this position, present only when the caller asked for
                // v1.Position-002. The Visibility tab reads it to list the primary position's
                // membership beside the shared positions', which is what the enlil-t8 Project Plan
                // detail this was ported from does.
                const positionAccountUsers = position.ListOfAccountUser ? position.ListOfAccountUser.AccountUser : null;
                row.AccountUsers = positionAccountUsers === undefined || positionAccountUsers === null
                    ? [] : (Array.isArray(positionAccountUsers) ? positionAccountUsers : [positionAccountUsers]);
                row.OrganizationUSID = position.OrganizationUSID;
                row.OrganizationName = position.OrganizationName;
                row.Name = position.Name;
                row.Status = position.Status;

                row.CreatedDatetime = position.CreatedDatetime;
                row.LastModifiedDatetime = position.LastModifiedDatetime;
                row.Keyword = position.Keyword;
                row.Realm = position.Realm;

                row.ListOfAccountUser = {
                    AccountUser: []
                };

                if ("ListOfAccountUser" in position) {
                    for (let j = 0; j < position["ListOfAccountUser"]["AccountUser"].length; j++) {
                        let employee: any = position["ListOfAccountUser"]["AccountUser"][j];

                        let employee_row: any = {};

                        employee_row.RowSelected = false;
                        employee_row.USID = employee.USID;
                        employee_row.UserUSID = employee.UserUSID;
                        employee_row.Email = employee.Email;
                        employee_row.Name = employee.Name;
                        employee_row.Confirmed = employee.Confirmed;
                        employee_row.Locked = employee.Locked;
                        employee_row.Active = employee.Active;
                        employee_row.CreatedDatetime = employee.CreatedDatetime;
                        employee_row.LastModifiedDatetime = employee.LastModifiedDatetime;
                        employee_row.Action = null;

                        row.ListOfAccountUser.AccountUser.push(employee_row);
                    }
                }
                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1PositionAccountUserIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input.PlatformMessage["ListOfPosition"] !== undefined) {
        if (input.PlatformMessage["ListOfPosition"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfPosition"].Count;
        }

        let results: any[] = [];

        if ("Position" in input.PlatformMessage["ListOfPosition"]) {
            for (let i = 0; i < input.PlatformMessage["ListOfPosition"]["Position"].length; i++) {
                let position = input.PlatformMessage["ListOfPosition"]["Position"][i];

                for (let j = 0; j < position["ListOfAccountUser"]["AccountUser"].length; j++) {
                    let accountUser: any = position["ListOfAccountUser"]["AccountUser"][j];

                    let row: any = {};

                    row.RowSelected = false;
                    row.USID = accountUser.USID;
                    row.UserUSID = accountUser.UserUSID;
                    row.Email = accountUser.Email;
                    row.Name = accountUser.Name;
                    row.Confirmed = accountUser.Confirmed;
                    row.Locked = accountUser.Locked;
                    row.Active = accountUser.Active;
                    row.CreatedDatetime = accountUser.CreatedDatetime;
                    row.LastModifiedDatetime = accountUser.LastModifiedDatetime;
                    row.Action = null;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (position["ListOfAccountUser"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = position["ListOfAccountUser"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1PrivilegeIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input.PlatformMessage["ListOfPrivilege"] !== undefined) {
        if (input.PlatformMessage["ListOfPrivilege"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfPrivilege"].Count;
        }

        let results: any[] = [];

        if ("Privilege" in input.PlatformMessage["ListOfPrivilege"]) {
            for (let i = 0; i < input.PlatformMessage["ListOfPrivilege"]["Privilege"].length; i++) {
                let privilege = input.PlatformMessage["ListOfPrivilege"]["Privilege"][i];

                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = privilege.USID;
                row.Name = privilege.Name;

                row.ListOfGroup = privilege.ListOfGroup;
                row.ListOfPrivilegeConstraint = privilege.ListOfPrivilegeConstraint;
                row.CreatedDatetime = privilege.CreatedDatetime;
                row.LastModifiedDatetime = privilege.LastModifiedDatetime;
                row.Keyword = privilege.Keyword;
                row.Realm = privilege.Realm;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1RoleIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input.PlatformMessage["ListOfRole"] !== undefined) {
        if (input.PlatformMessage["ListOfRole"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfRole"].Count;
        }

        let results: any[] = [];

        if ("Role" in input.PlatformMessage["ListOfRole"]) {
            for (let i = 0; i < input.PlatformMessage["ListOfRole"]["Role"].length; i++) {
                let role = input.PlatformMessage["ListOfRole"]["Role"][i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = role.USID;
                row.Name = role.Name;
                row.Status = role.Status;

                row.CreatedDatetime = role.CreatedDatetime;
                row.LastModifiedDatetime = role.LastModifiedDatetime;
                row.Keyword = role.Keyword;
                row.Realm = role.Realm;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1RoleAccountUserIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input.PlatformMessage["ListOfRole"] !== undefined) {
        if (input.PlatformMessage["ListOfRole"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfRole"].Count;
        }

        let results: any[] = [];

        if ("Role" in input.PlatformMessage["ListOfRole"]) {
            for (let i = 0; i < input.PlatformMessage["ListOfRole"]["Role"].length; i++) {
                let role = input.PlatformMessage["ListOfRole"]["Role"][i];

                for (let j = 0; j < role["ListOfAccountUser"]["AccountUser"].length; j++) {
                    let accountUser: any = role["ListOfAccountUser"]["AccountUser"][j];

                    let row: any = {};

                    row.RowSelected = false;
                    row.USID = accountUser.USID;
                    row.UserUSID = accountUser.UserUSID;
                    row.Email = accountUser.Email;
                    row.Name = accountUser.Name;
                    row.Confirmed = accountUser.Confirmed;
                    row.Locked = accountUser.Locked;
                    row.Active = accountUser.Active;
                    row.CreatedDatetime = accountUser.CreatedDatetime;
                    row.LastModifiedDatetime = accountUser.LastModifiedDatetime;
                    row.Action = null;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (role["ListOfAccountUser"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = role["ListOfAccountUser"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1RolePrivilegeIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input.PlatformMessage["ListOfRole"] !== undefined) {
        if (input.PlatformMessage["ListOfRole"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfRole"].Count;
        }

        let results: any[] = [];

        if ("Role" in input.PlatformMessage["ListOfRole"]) {
            for (let i = 0; i < input.PlatformMessage["ListOfRole"]["Role"].length; i++) {
                let role = input.PlatformMessage["ListOfRole"]["Role"][i];

                for (let j = 0; j < role["ListOfPrivilege"]["Privilege"].length; j++) {
                    let privilege: any = role["ListOfPrivilege"]["Privilege"][j];

                    let row: any = {};

                    row.RowSelected = false;
                    row.USID = privilege.USID;
                    row.RoleUSID = role.USID;
                    row.Realm = role.Realm;
                    row.Name = privilege.Name;
                    row.CreatedDatetime = privilege.CreatedDatetime;
                    row.LastModifiedDatetime = privilege.LastModifiedDatetime;
                    row.Action = null;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (role["ListOfPrivilege"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = role["ListOfPrivilege"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1UserGroupIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input.PlatformMessage["ListOfUserGroup"] !== undefined) {
        if (input.PlatformMessage["ListOfUserGroup"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfUserGroup"].Count;
        }

        let results: any[] = [];

        if ("UserGroup" in input.PlatformMessage["ListOfUserGroup"]) {
            for (let i = 0; i < input.PlatformMessage["ListOfUserGroup"]["UserGroup"].length; i++) {
                let user_group = input.PlatformMessage["ListOfUserGroup"]["UserGroup"][i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = user_group.USID;
                row.PrimaryAccountUserUSID = user_group.PrimaryAccountUserUSID;
                row.PrimaryAccountUserName = user_group.PrimaryAccountUserName;
                row.Name = user_group.Name;
                row.Status = user_group.Status;

                row.CreatedDatetime = user_group.CreatedDatetime;
                row.LastModifiedDatetime = user_group.LastModifiedDatetime;
                row.Keyword = user_group.Keyword;
                row.Realm = user_group.Realm;

                row.ListOfAccountUser = {
                    AccountUser: []
                };

                if ("ListOfAccountUser" in user_group) {
                    for (let j = 0; j < user_group["ListOfAccountUser"]["AccountUser"].length; j++) {
                        let employee: any = user_group["ListOfAccountUser"]["AccountUser"][j];

                        let employee_row: any = {};

                        employee_row.RowSelected = false;
                        employee_row.USID = employee.USID;
                        employee_row.UserUSID = employee.UserUSID;
                        employee_row.Email = employee.Email;
                        employee_row.Name = employee.Name;
                        employee_row.Confirmed = employee.Confirmed;
                        employee_row.Locked = employee.Locked;
                        employee_row.Active = employee.Active;
                        employee_row.CreatedDatetime = employee.CreatedDatetime;
                        employee_row.LastModifiedDatetime = employee.LastModifiedDatetime;
                        employee_row.Action = null;

                        row.ListOfAccountUser.AccountUser.push(employee_row);
                    }
                }

                // The same array under the name the Visibility tab reads for every owner type, so
                // one accessor covers positions, user groups and work groups.
                row.AccountUsers = row.ListOfAccountUser.AccountUser;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1UserGroupAccountUserIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input.PlatformMessage["ListOfUserGroup"] !== undefined) {
        if (input.PlatformMessage["ListOfUserGroup"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfUserGroup"].Count;
        }

        let results: any[] = [];

        if ("UserGroup" in input.PlatformMessage["ListOfUserGroup"]) {
            for (let i = 0; i < input.PlatformMessage["ListOfUserGroup"]["UserGroup"].length; i++) {
                let user_group = input.PlatformMessage["ListOfUserGroup"]["UserGroup"][i];

                for (let j = 0; j < user_group["ListOfAccountUser"]["AccountUser"].length; j++) {
                    let accountUser: any = user_group["ListOfAccountUser"]["AccountUser"][j];

                    let row: any = {};

                    row.RowSelected = false;
                    row.USID = accountUser.USID;
                    row.UserUSID = accountUser.UserUSID;
                    row.Email = accountUser.Email;
                    row.Name = accountUser.Name;
                    row.Confirmed = accountUser.Confirmed;
                    row.Locked = accountUser.Locked;
                    row.Active = accountUser.Active;
                    row.CreatedDatetime = accountUser.CreatedDatetime;
                    row.LastModifiedDatetime = accountUser.LastModifiedDatetime;
                    row.Action = null;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (user_group["ListOfAccountUser"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = user_group["ListOfAccountUser"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1WorkGroupIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input.PlatformMessage["ListOfWorkGroup"] !== undefined) {
        if (input.PlatformMessage["ListOfWorkGroup"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfWorkGroup"].Count;
        }

        let results: any[] = [];

        if ("WorkGroup" in input.PlatformMessage["ListOfWorkGroup"]) {
            for (let i = 0; i < input.PlatformMessage["ListOfWorkGroup"]["WorkGroup"].length; i++) {
                let work_group = input.PlatformMessage["ListOfWorkGroup"]["WorkGroup"][i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = work_group.USID;
                row.PrimaryAccountUserUSID = work_group.PrimaryAccountUserUSID;
                row.PrimaryAccountUserName = work_group.PrimaryAccountUserName;
                row.Name = work_group.Name;
                // The work group's DIRECT members. Note this is only the direct ones: a person can
                // also hold a work group through their position, organisation or user group, and
                // those paths are resolved at login rather than by this document.
                const workGroupAccountUsers = work_group.ListOfWorkGroupAccountUser
                    ? work_group.ListOfWorkGroupAccountUser.WorkGroupAccountUser : null;
                row.AccountUsers = workGroupAccountUsers === undefined || workGroupAccountUsers === null
                    ? [] : (Array.isArray(workGroupAccountUsers) ? workGroupAccountUsers : [workGroupAccountUsers]);
                row.Status = work_group.Status;
                row.ListOfOrganization = work_group.ListOfOrganization;
                row.ListOfPosition = work_group.ListOfPosition;
                row.ListOfUserGroup = work_group.ListOfUserGroup;
                row.ListOfWorkGroupAccountUser = work_group.ListOfWorkGroupAccountUser;
                row.CreatedDatetime = work_group.CreatedDatetime;
                row.LastModifiedDatetime = work_group.LastModifiedDatetime;
                row.Keyword = work_group.Keyword;
                row.Realm = work_group.Realm;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1WorkGroupAccountUserIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input.PlatformMessage["ListOfWorkGroup"] !== undefined) {
        if (input.PlatformMessage["ListOfWorkGroup"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfWorkGroup"].Count;
        }

        let results: any[] = [];

        if ("WorkGroup" in input.PlatformMessage["ListOfWorkGroup"]) {
            for (let i = 0; i < input.PlatformMessage["ListOfWorkGroup"]["WorkGroup"].length; i++) {
                let work_group = input.PlatformMessage["ListOfWorkGroup"]["WorkGroup"][i];

                for (let j = 0; j < work_group["ListOfWorkGroupAccountUser"]["WorkGroupAccountUser"].length; j++) {
                    let accountUser: any = work_group["ListOfWorkGroupAccountUser"]["WorkGroupAccountUser"][j];

                    let row: any = {};

                    row.RowSelected = false;
                    row.USID = accountUser.USID;
                    row.UserUSID = accountUser.UserUSID;
                    row.Email = accountUser.Email;
                    row.Name = accountUser.Name;
                    row.Confirmed = accountUser.Confirmed;
                    row.Locked = accountUser.Locked;
                    row.Active = accountUser.Active;
                    row.CreatedDatetime = accountUser.CreatedDatetime;
                    row.LastModifiedDatetime = accountUser.LastModifiedDatetime;
                    row.Action = null;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (work_group["ListOfWorkGroupAccountUser"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = work_group["ListOfWorkGroupAccountUser"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1WorkGroupOrganizationIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input.PlatformMessage["ListOfWorkGroup"] !== undefined) {
        if (input.PlatformMessage["ListOfWorkGroup"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfWorkGroup"].Count;
        }

        let results: any[] = [];

        if ("WorkGroup" in input.PlatformMessage["ListOfWorkGroup"]) {
            for (let i = 0; i < input.PlatformMessage["ListOfWorkGroup"]["WorkGroup"].length; i++) {
                let work_group = input.PlatformMessage["ListOfWorkGroup"]["WorkGroup"][i];

                for (let j = 0; j < work_group["ListOfOrganization"]["Organization"].length; j++) {
                    let organization: any = work_group["ListOfOrganization"]["Organization"][j];

                    let row: any = {};

                    row.RowSelected = false;
                    row.USID = organization.USID;
                    row.Realm = organization.Realm;
                    row.ParentUSID = organization.ParentUSID;
                    row.ParentOrganizationName = organization.ParentOrganizationName;
                    row.OrganizationType = organization.OrganizationType;
                    row.Name = organization.Name;
                    row.CreatedDatetime = organization.CreatedDatetime;
                    row.LastModifiedDatetime = organization.LastModifiedDatetime;
                    row.Action = null;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (work_group["ListOfOrganization"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = work_group["ListOfOrganization"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1WorkGroupPositionIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input.PlatformMessage["ListOfWorkGroup"] !== undefined) {
        if (input.PlatformMessage["ListOfWorkGroup"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfWorkGroup"].Count;
        }

        let results: any[] = [];

        if ("WorkGroup" in input.PlatformMessage["ListOfWorkGroup"]) {
            for (let i = 0; i < input.PlatformMessage["ListOfWorkGroup"]["WorkGroup"].length; i++) {
                let work_group = input.PlatformMessage["ListOfWorkGroup"]["WorkGroup"][i];

                for (let j = 0; j < work_group["ListOfPosition"]["Position"].length; j++) {
                    let position: any = work_group["ListOfPosition"]["Position"][j];

                    let row: any = {};

                    row.RowSelected = false;
                    row.USID = position.USID;
                    row.Realm = position.Realm;
                    row.ParentUSID = position.ParentUSID;
                    row.ParentPositionName = position.ParentPositionName;
                    row.PrimaryAccountUserUSID = position.PrimaryAccountUserUSID;
                    row.PrimaryAccountUserName = position.PrimaryAccountUserName;
                    row.OrganizationUSID = position.OrganizationUSID;
                    row.OrganizationName = position.OrganizationName;
                    row.Name = position.Name;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (work_group["ListOfPosition"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = work_group["ListOfPosition"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1WorkGroupUserGroupIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input.PlatformMessage["ListOfWorkGroup"] !== undefined) {
        if (input.PlatformMessage["ListOfWorkGroup"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfWorkGroup"].Count;
        }

        let results: any[] = [];

        if ("WorkGroup" in input.PlatformMessage["ListOfWorkGroup"]) {
            for (let i = 0; i < input.PlatformMessage["ListOfWorkGroup"]["WorkGroup"].length; i++) {
                let work_group = input.PlatformMessage["ListOfWorkGroup"]["WorkGroup"][i];

                for (let j = 0; j < work_group["ListOfUserGroup"]["UserGroup"].length; j++) {
                    let userGroup: any = work_group["ListOfUserGroup"]["UserGroup"][j];

                    let row: any = {};

                    row.RowSelected = false;
                    row.USID = userGroup.USID;
                    row.Realm = userGroup.Realm;
                    row.PrimaryAccountUserUSID = userGroup.PrimaryAccountUserUSID;
                    row.PrimaryAccountUserName = userGroup.PrimaryAccountUserName;
                    row.Name = userGroup.Name;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (work_group["ListOfUserGroup"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = work_group["ListOfUserGroup"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1AccountUserPositionIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input.PlatformMessage["ListOfAccountUser"] !== undefined) {
        if (input.PlatformMessage["ListOfAccountUser"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfAccountUser"].Count;
        }

        let results: any[] = [];

        if ("AccountUser" in input.PlatformMessage["ListOfAccountUser"]) {
            for (let i = 0; i < input.PlatformMessage["ListOfAccountUser"]["AccountUser"].length; i++) {
                let employee = input.PlatformMessage["ListOfAccountUser"]["AccountUser"][i];

                for (let j = 0; j < employee["ListOfPosition"]["Position"].length; j++) {
                    let position: any = employee["ListOfPosition"]["Position"][j];

                    let row: any = {};

                    row.RowNum = i;
                    row.RowSelected = false;

                    row.USID = position.USID;
                    row.ParentUSID = position.ParentUSID;
                    row.ParentPositionName = position.ParentPositionName;
                    row.Name = position.Name;
                    row.Status = position.Status;

                    row.CreatedDatetime = position.CreatedDatetime;
                    row.LastModifiedDatetime = position.LastModifiedDatetime;
                    row.Keyword = position.Keyword;
                    row.Realm = position.Realm;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (employee["ListOfPosition"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = employee["ListOfPosition"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1AccountUserUserGroupIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input.PlatformMessage["ListOfAccountUser"] !== undefined) {
        if (input.PlatformMessage["ListOfAccountUser"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfAccountUser"].Count;
        }

        let results: any[] = [];

        if ("AccountUser" in input.PlatformMessage["ListOfAccountUser"]) {
            for (let i = 0; i < input.PlatformMessage["ListOfAccountUser"]["AccountUser"].length; i++) {
                let employee = input.PlatformMessage["ListOfAccountUser"]["AccountUser"][i];

                for (let j = 0; j < employee["ListOfUserGroup"]["UserGroup"].length; j++) {
                    let user_group: any = employee["ListOfUserGroup"]["UserGroup"][j];

                    let row: any = {};

                    row.RowNum = i;
                    row.RowSelected = false;

                    row.USID = user_group.USID;
                    row.PrimaryAccountUserUSID = user_group.PrimaryAccountUserUSID;
                    row.PrimaryAccountUserName = user_group.PrimaryAccountUserName;
                    row.Name = user_group.Name;
                    row.Status = user_group.Status;

                    row.CreatedDatetime = user_group.CreatedDatetime;
                    row.LastModifiedDatetime = user_group.LastModifiedDatetime;
                    row.Keyword = user_group.Keyword;
                    row.Realm = user_group.Realm;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (employee["ListOfUserGroup"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = employee["ListOfUserGroup"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1AccountUserWorkGroupIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input.PlatformMessage["ListOfAccountUser"] !== undefined) {
        if (input.PlatformMessage["ListOfAccountUser"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfAccountUser"].Count;
        }

        let results: any[] = [];

        if ("AccountUser" in input.PlatformMessage["ListOfAccountUser"]) {
            for (let i = 0; i < input.PlatformMessage["ListOfAccountUser"]["AccountUser"].length; i++) {
                let employee = input.PlatformMessage["ListOfAccountUser"]["AccountUser"][i];

                for (let j = 0; j < employee["ListOfWorkGroup"]["WorkGroup"].length; j++) {
                    let work_group: any = employee["ListOfWorkGroup"]["WorkGroup"][j];

                    let row: any = {};

                    row.RowNum = i;
                    row.RowSelected = false;

                    row.USID = work_group.USID;
                    row.PrimaryAccountUserUSID = work_group.PrimaryAccountUserUSID;
                    row.PrimaryAccountUserName = work_group.PrimaryAccountUserName;
                    row.Name = work_group.Name;
                    row.Status = work_group.Status;

                    row.CreatedDatetime = work_group.CreatedDatetime;
                    row.LastModifiedDatetime = work_group.LastModifiedDatetime;
                    row.Keyword = work_group.Keyword;
                    row.Realm = work_group.Realm;

                    row["__operation"] = "query results";

                    results.push(row);
                }
                if (employee["ListOfWorkGroup"].Count === undefined) {
                    output["Count"] = 0;
                } else {
                    output["Count"] = employee["ListOfWorkGroup"].Count;
                }
            }
        }
        output["Results"] = results;
    }
    return output;
};

export const V1SupplierRevisionIDOCToArray = (input: any) => {
    let output: any = {};

    if (input["PlatformMessage"] && input.PlatformMessage["ListOfSupplierRevision"] !== undefined) {
        if (input.PlatformMessage["ListOfSupplierRevision"].Count === undefined) {
            output["Count"] = 0;
        } else {
            output["Count"] = input.PlatformMessage["ListOfSupplierRevision"].Count;
        }

        let results: any[] = [];

        if ("SupplierRevision" in input.PlatformMessage["ListOfSupplierRevision"]) {
            for (let i = 0; i < input.PlatformMessage["ListOfSupplierRevision"]["SupplierRevision"].length; i++) {
                let document_revision = input.PlatformMessage["ListOfSupplierRevision"]["SupplierRevision"][i];
                let row: any = {};

                row.RowNum = i;
                row.RowSelected = false;

                row.USID = document_revision.USID;
                row.DocumentUSID = document_revision.DocumentUSID;
                row.DocumentID = document_revision.DocumentID;
                row.DocumentIDPlusRevision = document_revision.DocumentIDPlusRevision;
                row.DocumentTypeUSID = document_revision.DocumentTypeUSID;
                row.DocumentTypeGroup = document_revision.DocumentTypeGroup;
                row.DocumentTypeAcronym = document_revision.DocumentTypeAcronm;
                row.Version = document_revision.Version;
                row.Description = document_revision.Description;
                row.Name = document_revision.Name;
                row.Status = document_revision.Status;
                row.DisplayStatus = document_revision.DisplayStatus;
                row.ParentEquipmentUSID = document_revision.ParentEquipmentUSID;
                row.Revision = document_revision.Revision;
                row.RevisionStage = document_revision.RevisionStage;
                row.OwnerUSID = document_revision.OwnerUSID;
                row.OwnerUserUSID = document_revision.OwnerUserUSID;
                row.OwnerUserName = document_revision.OwnerUserName;
                row.ApprovalRequestUSID = document_revision.ApprovalRequestUSID;
                row.ApprovalRequestID = document_revision.ApprovalRequestID;
                row.RevisionChangeType = document_revision.RevisionChangeType;
                row.DeprecatedAt = document_revision.DeprecatedAt;
                row.ReleasedAt = document_revision.ReleasedAt;
                row.ObsoletedAt = document_revision.ObsoletedAt;
                row.Retrain = document_revision.Retrain;
                row.PlatformFormInput = document_revision.PlatformFormInput;
                row.FormDocumentRevisionUSID = document_revision.FormDocumentRevisionUSID;
                row.ExternalID = document_revision.ExternalID;
                row.RenderHTML = document_revision.RenderHTML;
                row.PDFUSID = document_revision.PDFUSID;
                row.SubRevision = document_revision.SubRevision;
                row.DisplayRevision = document_revision.DisplayRevision;
                row.PreCalc = document_revision.PreCalc;
                row.Schema = document_revision.Schema;
                row.EquipmentStatus = document_revision.EquipmentStatus;
                row.PurchaseOrderStatus = document_revision.PurchaseOrderStatus;
                row.LotStatus = document_revision.LotStatus;
                row.EffectiveDate = document_revision.EffectiveDate;
                row.PrimaryAttachmentUSID = document_revision.PrimaryAttachmentUSID;
                row.LastZipFileUpdate = document_revision.LastZipFileUpdate;
                row.ApprovedAt = document_revision.ApprovedAt;
                row.CreatedDatetime = document_revision.CreatedDatetime;
                row.LastModifiedDatetime = document_revision.LastModifiedDatetime;
                row.Keyword = document_revision.Keyword;
                row.Realm = document_revision.CompanyUSID;

                row["__operation"] = "query results";

                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

// Foundation objects. Documents are ObjectRevision rows filtered to ObjectClassification =
// "Document"; the same shape serves the other eight classifications, so these helpers are named for
// the object model rather than for Documents.
//
// Every hop tolerates a missing grouping tag: the IDOC omits ListOfX entirely when nothing matches,
// and a single result can arrive as an object rather than a one-element array.
const listOf = (input: any, groupingTag: string, tag: string) => {
    const output: any = {Count: 0};
    const results: any[] = [];

    const group = input?.["PlatformMessage"]?.[groupingTag];
    if (group === undefined) {
        output["Results"] = results;
        return output;
    }

    output["Count"] = group.Count === undefined ? 0 : group.Count;

    let rows = group[tag];
    if (rows === undefined) rows = [];
    if (!Array.isArray(rows)) rows = [rows];

    output["Rows"] = rows;
    output["Results"] = results;
    return output;
};

/**
 * @param groupingTag  the list tag the document wraps its rows in. Defaults to the generic
 *                     document's, so every existing caller is unaffected. A per-classification
 *                     document uses its own -- ListOfPurchaseOrderRevision and PurchaseOrderRevision
 *                     -- and reading it with these defaults finds no rows and reports an empty grid
 *                     rather than an error, which is the failure this parameter exists to prevent.
 */
export const V1ObjectRevisionIDOCToArray = (input: any,
                                            groupingTag: string = "ListOfObjectRevision",
                                            rowTag: string = "ObjectRevision") => {
    const base = listOf(input, groupingTag, rowTag);
    const output: any = {Count: base.Count};
    const results: any[] = [];

    (base.Rows ?? []).forEach((row: any, i: number) => {
        const r: any = {};
        r.RowNum = i;
        r.RowSelected = false;

        r.USID = row.USID;
        r.ObjectUSID = row.ObjectUSID;
        r.ObjectClassification = row.ObjectClassification;
        r.ObjectID = row.ObjectID;
        // THE TYPE, WHICH THE SERVER HAS ALWAYS SENT AND THIS HAS ALWAYS DROPPED. Every card on
        // every object list drew "Type --", and it looked like a missing attribute: the component
        // declares ObjectTypeAcronym, the document carries it userVisible, the two-hop join
        // resolves it (SupplierRevision answers 'SUP-' when asked directly), and the data is
        // complete -- 136 of 136 suppliers have an acronym. It died here, in a hand-written
        // whitelist, where a field that is not copied is indistinguishable from a field that is
        // null. See the guard in cardFields.test.ts, which now walks this function.
        r.ObjectTypeAcronym = row.ObjectTypeAcronym;
        r.ObjectTypeName = row.ObjectTypeName;
        r.Revision = row.Revision;
        r.DisplayRevision = row.DisplayRevision;
        r.Status = row.Status;
        r.ApprovalStatus = row.ApprovalStatus;
        r.IsCurrent = row.IsCurrent;
        r.Name = row.Name;
        r.Description = row.Description;
        r.CreatedByUSID = row.CreatedByUSID;
        r.PrimaryPositionUSID = row.PrimaryPositionUSID;
        r.PrimaryUserGroupUSID = row.PrimaryUserGroupUSID;
        r.PrimaryWorkGroupUSID = row.PrimaryWorkGroupUSID;
        r.PrimaryPositionName = row.PrimaryPositionName;
        r.PrimaryUserGroupPrimaryAccountUserName = row.PrimaryUserGroupPrimaryAccountUserName;
        r.PrimaryWorkGroupPrimaryAccountUserName = row.PrimaryWorkGroupPrimaryAccountUserName;
        r.ReleasedDatetime = row.ReleasedDatetime;
        r.EffectiveDatetime = row.EffectiveDatetime;
        r.ApprovedDatetime = row.ApprovedDatetime;
        r.CreatedDatetime = row.CreatedDatetime;
        r.LastModifiedDatetime = row.LastModifiedDatetime;
        r.Realm = row.Realm;

        r["__operation"] = "query results";
        results.push(r);
    });

    output["Results"] = results;
    return output;
};

// The relationship TYPES, which is configuration rather than data: the four fields are the type's
// own name and the two directional phrasings a row uses depending on which end you are reading from.
export const V1ObjectRelationshipTypeIDOCToArray = (input: any) => {
    const base = listOf(input, "ListOfObjectRelationshipType", "ObjectRelationshipType");
    const output: any = {Count: base.Count};
    const results: any[] = [];

    (base.Rows ?? []).forEach((row: any) => {
        results.push({
            RowSelected: false,
            USID: row.USID,
            Name: row.Name,
            SourceRelationshipName: row.SourceRelationshipName,
            TargetRelationshipName: row.TargetRelationshipName,
            __operation: "query results",
        });
    });

    output.Results = results;
    return output;
};

export const V1ObjectRelationshipIDOCToArray = (input: any) => {
    const base = listOf(input, "ListOfObjectRelationship", "ObjectRelationship");
    const output: any = {Count: base.Count};
    const results: any[] = [];

    (base.Rows ?? []).forEach((row: any, i: number) => {
        const r: any = {};
        r.RowNum = i;
        r.RowSelected = false;

        r.USID = row.USID;
        r.ParentUSID = row.ParentUSID;
        r.ChildUSID = row.ChildUSID;
        r.ObjectRelationshipTypeUSID = row.ObjectRelationshipTypeUSID;
        r.ParentName = row.ParentName;
        r.ChildName = row.ChildName;
        r.ParentObjectID = row.ParentObjectID;
        r.ChildObjectID = row.ChildObjectID;
        r.ParentDisplayRevision = row.ParentDisplayRevision;
        r.ChildDisplayRevision = row.ChildDisplayRevision;
        r.ParentStatus = row.ParentStatus;
        r.ChildStatus = row.ChildStatus;
        r.ParentObjectClassification = row.ParentObjectClassification;
        r.ChildObjectClassification = row.ChildObjectClassification;
        r.ParentRevisionUSID = row.ParentRevisionUSID;
        r.ChildRevisionUSID = row.ChildRevisionUSID;
        // Float/pin state, its drift baseline, and what the pin resolves to. THIS CONVERTER
        // ENUMERATES, so a field the server faithfully sends is dropped here unless it is named --
        // which looks exactly like a backend that never returned it.
        r.ChildPinnedRevisionUSID = row.ChildPinnedRevisionUSID;
        r.ChildRevisionAtCreationUSID = row.ChildRevisionAtCreationUSID;
        r.ParentRevisionAtCreationUSID = row.ParentRevisionAtCreationUSID;
        r.ChildPinnedName = row.ChildPinnedName;
        r.ChildPinnedStatus = row.ChildPinnedStatus;
        r.ChildPinnedDisplayRevision = row.ChildPinnedDisplayRevision;
        r.ChildRevisionAtCreationDisplayRevision = row.ChildRevisionAtCreationDisplayRevision;
        r.ObjectRelationshipTypeName = row.ObjectRelationshipTypeName;
        r.SourceRelationshipName = row.SourceRelationshipName;
        r.TargetRelationshipName = row.TargetRelationshipName;
        r.CreatedDatetime = row.CreatedDatetime;
        r.LastModifiedDatetime = row.LastModifiedDatetime;
        r.Realm = row.Realm;

        r["__operation"] = "query results";
        results.push(r);
    });

    output["Results"] = results;
    return output;
};

export const V1ObjectAuditHistoryIDOCToArray = (input: any) => {
    const base = listOf(input, "ListOfObjectAuditHistory", "ObjectAuditHistory");
    const output: any = {Count: base.Count};
    const results: any[] = [];

    (base.Rows ?? []).forEach((row: any, i: number) => {
        const r: any = {};
        r.RowNum = i;
        r.RowSelected = false;

        r.USID = row.USID;
        r.ModificationType = row.ModificationType;
        r.SessionIdentifier = row.SessionIdentifier;
        r.ObjectUSID = row.ObjectUSID;
        r.ObjectClassification = row.ObjectClassification;
        r.ObjectRevisionUSID = row.ObjectRevisionUSID;
        r.RevisionName = row.RevisionName;
        r.ObjectRelationshipUSID = row.ObjectRelationshipUSID;
        r.CreatedByUSID = row.CreatedByUSID;
        r.CreatedByName = row.CreatedByName;
        r.CreatedByEmail = row.CreatedByEmail;
        // StorageTypeJSON: base64-encoded JSON on the wire, so it is NOT already an object here.
        r.Change = row.Change;
        r.CreatedDatetime = row.CreatedDatetime;
        r.LastModifiedDatetime = row.LastModifiedDatetime;
        r.Realm = row.Realm;

        r["__operation"] = "query results";
        results.push(r);
    });

    output["Results"] = results;
    return output;
};

export const V1CapabilityIDOCToArray = (input: any) => {
    let output: any = {};
    if (input["PlatformMessage"] && input["PlatformMessage"]["ListOfCapability"] !== undefined) {
        output["Count"] = input["PlatformMessage"]["ListOfCapability"].Count === undefined ? 0 : input["PlatformMessage"]["ListOfCapability"].Count;
        let results: any[] = [];
        if ("Capability" in input["PlatformMessage"]["ListOfCapability"]) {
            let node = input["PlatformMessage"]["ListOfCapability"]["Capability"];
            let rows = Array.isArray(node) ? node : [node];
            for (let i = 0; i < rows.length; i++) {
                let c = rows[i];
                let row: any = {};
                row.RowNum = i;
                row.RowSelected = false;
                row.USID = c.USID;
                row.Name = c.Name;
                row.Description = c.Description;
                row.ObjectType = c.ObjectType;
                row.CreatedDatetime = c.CreatedDatetime;
                row.LastModifiedDatetime = c.LastModifiedDatetime;
                row.Realm = c.Realm;
                row["__operation"] = "query results";
                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

// A share's granted capabilities (t1/v1/membership_capabilities). MembershipUSID keys the row to a
// *_MEMBERSHIP share; CapabilityName/ObjectType ride along (LEFT-joined in the EC) for display.
export const V1MembershipCapabilityIDOCToArray = (input: any) => {
    let output: any = {};
    if (input["PlatformMessage"] && input["PlatformMessage"]["ListOfMembershipCapability"] !== undefined) {
        output["Count"] = input["PlatformMessage"]["ListOfMembershipCapability"].Count === undefined ? 0 : input["PlatformMessage"]["ListOfMembershipCapability"].Count;
        let results: any[] = [];
        if ("MembershipCapability" in input["PlatformMessage"]["ListOfMembershipCapability"]) {
            let node = input["PlatformMessage"]["ListOfMembershipCapability"]["MembershipCapability"];
            let rows = Array.isArray(node) ? node : [node];
            for (let i = 0; i < rows.length; i++) {
                let mc = rows[i];
                let row: any = {};
                row.RowNum = i;
                row.RowSelected = false;
                row.USID = mc.USID;
                row.MembershipUSID = mc.MembershipUSID;
                row.CapabilityUSID = mc.CapabilityUSID;
                row.CapabilityName = mc.CapabilityName;
                row.CapabilityObjectType = mc.CapabilityObjectType;
                row.CreatedDatetime = mc.CreatedDatetime;
                row.LastModifiedDatetime = mc.LastModifiedDatetime;
                row.Realm = mc.Realm;
                row["__operation"] = "query results";
                results.push(row);
            }
        }
        output["Results"] = results;
    }
    return output;
};

// THESE CONVERTERS ENUMERATE, and that is worth knowing before adding a field: a value the server
// sends faithfully is dropped here unless it is named below, which looks exactly like a backend that
// never returned it.
export const V1ChangeOrderIDOCToArray = (input: any) => {
    const base = listOf(input, "ListOfChangeOrder", "ChangeOrder");
    const output: any = {Count: base.Count};
    const results: any[] = [];

    (base.Rows ?? []).forEach((row: any, i: number) => {
        const r: any = {};
        r.RowNum = i;
        r.RowSelected = false;

        r.USID = row.USID;
        r.ChangeOrderID = row.ChangeOrderID;
        r.ObjectTypeUSID = row.ObjectTypeUSID;
        r.Title = row.Title;
        r.Description = row.Description;
        r.Justification = row.Justification;
        r.ImpactAssessment = row.ImpactAssessment;
        r.State = row.State;
        r.FormRevisionUSID = row.FormRevisionUSID;
        r.Schema = row.Schema;
        r.FormInput = row.FormInput;
        r.EffectiveDatetime = row.EffectiveDatetime;
        r.ClosedDatetime = row.ClosedDatetime;
        r.ReleasedInSingleAction = row.ReleasedInSingleAction;
        r.PrimaryPositionUSID = row.PrimaryPositionUSID;
        r.PrimaryUserGroupUSID = row.PrimaryUserGroupUSID;
        r.PrimaryWorkGroupUSID = row.PrimaryWorkGroupUSID;
        r.RaisedByUSID = row.RaisedByUSID;
        r.ObjectTypeName = row.ObjectTypeName;
        r.ObjectTypeAcronym = row.ObjectTypeAcronym;
        r.PrimaryPositionName = row.PrimaryPositionName;
        r.PrimaryUserGroupName = row.PrimaryUserGroupName;
        r.PrimaryWorkGroupName = row.PrimaryWorkGroupName;
        r.CreatedDatetime = row.CreatedDatetime;
        r.LastModifiedDatetime = row.LastModifiedDatetime;
        r.Realm = row.Realm;

        r["__operation"] = "query results";
        results.push(r);
    });

    output["Results"] = results;
    return output;
};

export const V1ChangeOrderTaskIDOCToArray = (input: any) => {
    const base = listOf(input, "ListOfChangeOrderTask", "ChangeOrderTask");
    const output: any = {Count: base.Count};
    const results: any[] = [];

    (base.Rows ?? []).forEach((row: any, i: number) => {
        const r: any = {};
        r.RowNum = i;
        r.RowSelected = false;

        r.USID = row.USID;
        r.ChangeOrderUSID = row.ChangeOrderUSID;
        r.Instruction = row.Instruction;
        r.AssigneeUSID = row.AssigneeUSID;
        r.AssigneeName = row.AssigneeName;
        r.Status = row.Status;
        r.Position = row.Position;
        r.CompletedDatetime = row.CompletedDatetime;
        r.CompletedByUSID = row.CompletedByUSID;
        r.CreatedDatetime = row.CreatedDatetime;
        r.LastModifiedDatetime = row.LastModifiedDatetime;
        r.Realm = row.Realm;

        results.push(r);
    });

    output.Rows = results;
    return output;
};

export const V1ChangeOrderMemberIDOCToArray = (input: any) => {
    const base = listOf(input, "ListOfChangeOrderMember", "ChangeOrderMember");
    const output: any = {Count: base.Count};
    const results: any[] = [];

    (base.Rows ?? []).forEach((row: any, i: number) => {
        const r: any = {};
        r.RowNum = i;
        r.RowSelected = false;

        r.USID = row.USID;
        r.ChangeOrderUSID = row.ChangeOrderUSID;
        r.TargetType = row.TargetType;
        r.RecordUSID = row.RecordUSID;
        // What the record WAS when it joined...
        r.RecordName = row.RecordName;
        r.RecordObjectID = row.RecordObjectID;
        r.RecordDisplayRevision = row.RecordDisplayRevision;
        r.ObjectTypeUSID = row.ObjectTypeUSID;
        r.ObjectTypeName = row.ObjectTypeName;
        r.ObjectClassification = row.ObjectClassification;
        r.Reason = row.Reason;
        r.Position = row.Position;
        r.AddedByUSID = row.AddedByUSID;
        r.AddedDatetime = row.AddedDatetime;
        // ...and what it is now. The difference is what tells a reader it has moved since.
        r.CurrentStatus = row.CurrentStatus;
        r.CurrentDisplayRevision = row.CurrentDisplayRevision;
        r.CurrentName = row.CurrentName;
        r.ObjectUSID = row.ObjectUSID;
        r.CreatedDatetime = row.CreatedDatetime;
        r.Realm = row.Realm;

        r["__operation"] = "query results";
        results.push(r);
    });

    output["Results"] = results;
    return output;
};

export const V1ObjectTypeIDOCToArray = (input: any) => {
    const base = listOf(input, "ListOfObjectType", "ObjectType");
    const output: any = {Count: base.Count};
    const results: any[] = [];

    (base.Rows ?? []).forEach((row: any, i: number) => {
        const r: any = {};
        r.RowNum = i;
        r.RowSelected = false;

        r.USID = row.USID;
        r.Name = row.Name;
        r.Acronym = row.Acronym;
        r.ObjectClassification = row.ObjectClassification;
        r.Active = row.Active;

        r["__operation"] = "query results";
        results.push(r);
    });

    output["Results"] = results;
    return output;
};

/**
 * v1.Project-001 into rows the buffer can hold.
 *
 * THE COUNTS ARE FLATTENED HERE, not by each caller. The document nests them -- `Counts.Contract`
 * -- which is right for a document and wrong for a grid, where a column is addressed by one
 * attribute name. Spreading them once means a card, a column and a sort all read the same
 * attribute rather than three callers each reaching into the same nested object.
 *
 * EVERY KIND IS PRESENT INCLUDING THE ZEROS, because the service returns them that way on purpose:
 * a key that vanished when empty would make every client re-derive the zero, and some would get
 * it wrong.
 */
export const V1ProjectIDOCToArray = (input: any) => {
    const output: any = {};
    const held = input?.PlatformMessage?.ListOfProject;

    output["Count"] = input?.PlatformMessage?.Count ?? 0;

    const results: any[] = [];
    const listed = held?.Project;
    const rows = listed === undefined || listed === null
        ? [] : (Array.isArray(listed) ? listed : [listed]);

    for (const project of rows) {
        const counts = project?.Counts ?? {};
        const row: any = {};
        row.RowSelected = false;
        row.USID = project.USID;
        row.Name = project.Name;
        row.Description = project.Description;
        row.Status = project.Status;
        row.CustomerObjectUSID = project.CustomerObjectUSID;
        // RESOLVED LATER, AGAINST THE CUSTOMER'S OWN READ, so it starts null rather than absent --
        // an attribute the metadata declares and the payload never sets reads as undefined, and a
        // card cannot tell that from "not named yet".
        row.CustomerName = null;
        row.ClosedDatetime = project.ClosedDatetime;
        row.CreatedDatetime = project.CreatedDatetime;
        row.CountProduct = counts.Product ?? 0;
        row.CountQuoteRequest = counts.QuoteRequest ?? 0;
        row.CountPreparedQuote = counts.PreparedQuote ?? 0;
        row.CountContract = counts.Contract ?? 0;
        row.CountBuildPlan = counts.BuildPlan ?? 0;
        row.CountFiled = row.CountProduct + row.CountQuoteRequest + row.CountPreparedQuote
            + row.CountContract + row.CountBuildPlan;
        results.push(row);
    }

    output["Results"] = results;
    return output;
};
